import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconButton } from "@mui/material";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

import Tooltip from "@mui/material/Tooltip";
import { MatrixIntervalControlsProps } from './MatrixIntervalControls';
import Divider from '@mui/material/Divider';
import CommunicationSet from '../../../../models/communications/CommunicationSet';
import { useRowSelector } from '../../../../store/Hooks';
import Interval from '../../../../models/communications/Interval';
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import { navSliceActions } from '../../../../store/slices/NavSlice';
import { useDispatch } from 'react-redux';
import CloseIcon from "@mui/icons-material/Close";

interface IntervalToCommSetButtonAndMenuProps extends MatrixIntervalControlsProps {
  handleAssignCommSet?: any;
  handleUnassignCommSet?:any;
  handleAddExistingCommSet?:any;
  handleOpenEditCommunications?:any;
  inEditor?: boolean;
  editMode?:boolean;
}


const IntervalToCommSetButtonAndMenu = (props: IntervalToCommSetButtonAndMenuProps) => {
  const dispatch = useDispatch();
  const interval = useRowSelector(Interval, props.associatedInterval.id);
  const assignedCommunicationSet = useRowSelector(CommunicationSet, props.associatedInterval.communication_set_id || 0);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenEditCommunications = () => {
    if (props.handleOpenEditCommunications){
      props.handleOpenEditCommunications();
      handleClose(); 
      return;
    }
    dispatch(
      navSliceActions.openRightDrawer({
        content: null,
        type: "communications",
        resourceID: props.associatedInterval.id,
        resourceName: "interval",
        extraData: { editMode: props.editMode },
      }),
    );
    handleClose();

  };

  const handleAddExistingCommSet = () => {
    if (props.handleAddExistingCommSet){
      props.handleAddExistingCommSet();
      handleClose(); 
      return;
    }
    dispatch(
      navSliceActions.openModal({
        thisSet: props.setID,
        thisParent: props.parentID,
        type: "commset",
        intervalID: interval?.id
      }),
    );
    handleClose();
  };

  const handleUnassignCommSet = async () => {
    if (props.handleUnassignCommSet){
      props.handleUnassignCommSet();
      handleClose(); 
      return;
    }
    const updatedInterval = await interval?.update("communication_set_id", null)
    // if in an editor, just update redux and allow editor to commit the save
    if(!props.inEditor){
      updatedInterval?.save(); 
    }
    handleClose(); 
  }

  const handleAssignCommSet = async (id:number) => {
    if (props.handleAssignCommSet){
      props.handleAssignCommSet(id);
      handleClose(); 
      return;
    }
    const updatedInterval = await interval?.update("communication_set_id", id)

    // if in an editor, just update redux and allow editor to commit the save
    if(!props.inEditor){
      updatedInterval?.save(); 
    }
    handleClose();   
  }
  




  // sometimes dupes creep into this
  // remove them again as a failsafe
  // so they dont appear twice in the dropdown
  const distinctCommSetsForThisIntervalSet = props.commSetsForIntervalSet.reduce((acc:any, current:CommunicationSet) => {
    const x = acc.find((item:CommunicationSet) =>{ return item.id === current.id});
    if (!x) {
      return acc.concat([current]);
    } else {
      return acc;
    }
  }, []).filter((commset:CommunicationSet)=>{ // we dont need to see commsets this interval is already part of
    return (interval?.communication_set_id!==commset.id)
  });

  const inEditorButtonStyle =props.inEditor ?  {color: "#1976d2" , float: "right"} as any :  { marginTop: "-10px", color: interval?.communication_set_id ? "gray" : "#1976d2" }

  return (
    <span >
      <IconButton
        disabled={!props.editMode}
        style={inEditorButtonStyle}
        onClick={handleClick}
        id="demo-positioned-button"
        aria-expanded={open ? 'true' : undefined}
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"


      >
        <Tooltip title={"Update Communication Set for this Interval"}>
          <MoreTimeIcon sx={{ fontSize: props.inEditor? "20pt" : "15pt", marginLeft: props.inEditor ? "-100px" : "",marginBottom: "-5px" }} />
        </Tooltip>
      </IconButton>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {distinctCommSetsForThisIntervalSet.map((commSet: CommunicationSet) => {
          return (
            <MenuItem key={commSet.id} onClick={ async ()=>{ await handleAssignCommSet(commSet.id)  }}>
              <AccessTimeIcon style={{ color: "gray", fontSize: "10pt" }} />
              &nbsp;
              Assign {commSet.name} to interval {props.associatedInterval.name}
            </MenuItem>)
        })}
        <Divider />
        <MenuItem onClick={handleOpenEditCommunications}><AccessTimeIcon style={{ color: "green", fontSize: "10pt" }} /> &nbsp; Add New Communications Set</MenuItem>
        <MenuItem onClick={handleAddExistingCommSet}>< FolderOpenOutlinedIcon style={{ color: "gray", fontSize: "10pt" }}/> &nbsp; Assign Existing Communications Set</MenuItem>
        {assignedCommunicationSet && <Divider />}
        {assignedCommunicationSet && <MenuItem onClick={handleUnassignCommSet}>< CloseIcon style={{ color: "red", fontSize: "10pt" }}/> &nbsp; Unassign {assignedCommunicationSet.name} from interval {props.associatedInterval.name}</MenuItem>}

      </Menu>
    </span>
  );
}

export default IntervalToCommSetButtonAndMenu